/**
 * Given an array of collections return the collected properties (modulo operation)
 * @param  {Array} collections parameter for collection data
 * @return {Array} collected property datas for deeds section
 */
export const sumMonopolyCollections = collections => {

    const countProperties = (property_type, max) => {
        return collections
        .filter(collection => collection.color == property_type)
        .reduce(
            (total, collection) =>
                total + parseInt(collection.tickets.length, 10),
            0
        ) % max;
    }

    return [
        {"property_type":"dark blue","count":2,"collected": countProperties("dark blue", 2)},
        {"property_type":"brown","count":2,"collected": countProperties("brown", 2)},
        {"property_type":"light blue","count":3,"collected": countProperties("light blue", 3)},
        {"property_type":"pink","count":3,"collected": countProperties("pink", 3)},
        {"property_type":"orange","count":3,"collected": countProperties("orange", 3)},
        {"property_type":"red","count":3,"collected": countProperties("red", 3)},
        {"property_type":"yellow","count":3,"collected": countProperties("yellow", 3)},
        {"property_type":"green","count":3,"collected": countProperties("green", 3)},
        {"property_type":"railroad","count":4,"collected": countProperties("railroad", 4)},
    ];
};
